import 'bootstrap';
import 'bootstrap-select';
import 'slick-carousel/slick/slick.min';

import './components/ui/dropdown/dropdown';
import './components/ui/form/form';
import './components/ui/custom_radio/custom_radio';
import './components/ui/custom_checkbox/custom_checkbox';
import './components/ui/scroll_top/scroll_top';
import './components/ui/slider/slider';
import './components/blocks/menu/menu';
import './components/blocks/cities/cities';
import './components/blocks/mobile_filters/mobile_filters';
import './components/blocks/seo_block/seo_block';
import './components/blocks/nav/nav';
import './components/blocks/quick_sort/quick_sort';
import './components/blocks/overlay_bg_dark/overlay_bg_dark';
import './components/blocks/close_mob_filters/close_mob_filters';
import './components/blocks/constant_link/constant_link';
import './components/blocks/social_links/social_links';
import './components/blocks/auth_actions/auth_actions';
import './components/blocks/subcategory/subcategory';
import './components/containers/footer';
import './components/blocks/amazzing_filter/amazzing_filter';
import './components/blocks/join_tour_modal/join_tour_modal';
import './components/blocks/gallery/gallery';
import './components/blocks/calendar/calendar';

import './pages/post/post';
import './pages/my_account/my_account';
import './pages/product/product';
import './pages/product_location/product_location';
import './pages/stores/stores';
import collapse from './components/blocks/collapse/collapse';

function setIdProduct() {
    try {
        const elements = document.querySelectorAll('[data-id-product]');
        elements.forEach(element => {
            element.addEventListener('click', () => {
                const idProduct = element.getAttribute('data-id-product');
                document.querySelector('input[name="id_product"]').value = idProduct;
            });
        });
    } catch (error) {
        console.error(error);
    }

    $('.call_back__modal_close').click(function() {
        $('.call_back').removeClass('call_back--success');
    });

    $('.call_back').on('click', function(event) {
        if (!$(event.target).closest('.modal-dialog').length) {
            if (!$(event.target).hasClass('call_back__modal_close')) {
                $('.call_back').removeClass('call_back--success');
            }
        }
    });
}

function horizontalDevise() {
    return window.innerWidth > window.innerHeight;
}

function updateVideoWhenHorizontal(orientHorizontal = false) {
    if (orientHorizontal) {
        $('.modal_video').addClass('horizontal');
        // $('.filter_apply').addClass('horizontal');
    } else {
        $('.modal_video').removeClass('horizontal');
        // $('.filter_apply').removeClass('horizontal');
    }
}

function productAccordion() {
    $('.product__accordion_title').click(function () {
        const accordionItem = $(this).closest('.product__accordion_item');
        const accordionContent = $(this).siblings('.product__accordion_content');

        if (accordionContent.is(':visible')) {
            // Если контент открыт, сворачиваем его и удаляем класс "active"
            accordionContent.slideUp(function() {
                accordionItem.removeClass('active');
                const titleOffset = $(this).prev('.product__accordion_title').offset().top - 110;
                scrollToOffset(titleOffset);
            });
        } else {
            // Скрываем все открытые контенты и удаляем класс "active" у других элементов
            $('.product__accordion_content').slideUp();
            $('.product__accordion_item').removeClass('active');

            // Открываем текущий контент и добавляем класс "active" к текущему элементу
            accordionContent.slideDown(function() {
                accordionItem.addClass('active');
                const titleOffset = $(this).prev('.product__accordion_title').offset().top - 110;
                scrollToOffset(titleOffset);
            });
        }
    });

    $('.js__product__expand_btn').click(function () {
        // Развернуть все контенты и добавить класс "active" ко всем элементам
        $('.product__accordion_content').slideDown();
        $('.product__accordion_item').addClass('active');

        // Прокрутка в начало блока product__container
        const productContainer = $('.product__container');
        const containerOffset = productContainer.offset().top - 110;
        scrollToOffset(containerOffset);
    });

    $('.js__product__collapse_all_btn').click(function () {
        // Свернуть все контенты и удалить класс "active" у всех элементов
        $('.product__accordion_content').slideUp();
        $('.product__accordion_item').removeClass('active');

        // Прокрутка в начало блока product__container
        const productContainer = $('.product__container');
        const containerOffset = productContainer.offset().top - 110;
        scrollToOffset(containerOffset);
    });

    function scrollToOffset(offset) {
        $('html, body').animate({ scrollTop: offset }, 'slow');
    }
}
function handleMenuClick() {
    const menuItem = document.querySelector('.top_menu__item_with_dropdown');
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (windowWidth < 1200) {
        if (menuItem.classList.contains('active_top_menu__dropdown')) {
            menuItem.classList.remove('active_top_menu__dropdown');
        } else {
            menuItem.classList.add('active_top_menu__dropdown');
        }
    }
    window.addEventListener('scroll', function() {
        menuItem.classList.remove('active_top_menu__dropdown');
    });
}

function addProductIdForModalInfolists() {
    $('.js--call_back__title').on('click', function () {
        if ($(this).attr('data-product-id')) {
            $('#join_tour_form_infolists input[name="id_product"]').val($(this).attr('data-product-id'));
        }

        if ($('#joinTourModal').hasClass('join_tour_modal--success')) {
            $('#joinTourModal').removeClass('join_tour_modal--success');
            $('.js--join_tour_modal__form_item').val('');
        }
    });
}

$(document).ready(() => {
    setIdProduct();
    collapse();
    updateVideoWhenHorizontal(horizontalDevise());
    productAccordion();
    addProductIdForModalInfolists();
    document.querySelector('.js--top_menu__item_text').addEventListener('click', handleMenuClick);
});
window.onresize = function () {
    updateVideoWhenHorizontal(horizontalDevise());
};
